<template>
    <div class="tags-container">
        <div v-for="tag in tags" :key="tag.no" class="tag">
            <span>{{ tag.name }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductTags',
    components: {},
    props: {
        tags: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {},
};
</script>

<style lang="less" scoped>
.tags-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    position: absolute;
    right: 0;
    top: 0;
    .tag {
        align-items: center;
        background-color: #ffa039;
        color: rgba(0, 0, 0, 0.8);
        display: flex;
        font-size: 12px;
        font-weight: bold;
        height: 25px;
        justify-content: center;
        letter-spacing: -0.3px;
        margin: 0 0 1px 1px;
        min-width: 100px;
        padding: 0 10px;
    }
}
</style>
